exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ServiceCard_component_27-w {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n\n  width: 100%;\n}\n\n.ServiceCard_isMobile_38Q6 {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n", ""]);

// exports
exports.locals = {
	"component": "ServiceCard_component_27-w",
	"isMobile": "ServiceCard_isMobile_38Q6"
};